import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_hourly_options_dd_ComponentContextService } from './FootprintManager.hourly_options_dd.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-hourly_options_dd_single',
  templateUrl: './FootprintManager.hourly_options_dd_single.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FootprintManager_hourly_options_dd_singleComponent),
      multi: true
    }
  ]
})
export class FootprintManager_hourly_options_dd_singleComponent extends BaseComponent implements OnInit, ControlValueAccessor {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;
  
  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return false;
  }

  get isSingle() {
    return true;
  }

  options: Array<{ key: any; name: string; disabled?: boolean; }> = [
    {
      key: '00:00',
      name: '00:00',
      disabled: null
    },  
    {
      key: '00:30',
      name: '00:30',
      disabled: null
    },  
    {
      key: '01:00',
      name: '01:00',
      disabled: null
    },  
    {
      key: '01:30',
      name: '01:30',
      disabled: null
    },  
    {
      key: '02:00',
      name: '02:00',
      disabled: null
    },  
    {
      key: '02:30',
      name: '02:30',
      disabled: null
    },  
    {
      key: '03:00',
      name: '03:00',
      disabled: null
    },  
    {
      key: '03:30',
      name: '03:30',
      disabled: null
    },  
    {
      key: '04:00',
      name: '04:00',
      disabled: null
    },  
    {
      key: '04:30',
      name: '04:30',
      disabled: null
    },  
    {
      key: '05:00',
      name: '05:00',
      disabled: null
    },  
    {
      key: '05:30',
      name: '05:30',
      disabled: null
    },  
    {
      key: '06:00',
      name: '06:00',
      disabled: null
    },  
    {
      key: '06:30',
      name: '06:30',
      disabled: null
    },  
    {
      key: '07:00',
      name: '07:00',
      disabled: null
    },  
    {
      key: '07:30',
      name: '07:30',
      disabled: null
    },  
    {
      key: '08:00',
      name: '08:00',
      disabled: null
    },  
    {
      key: '08:30',
      name: '08:30',
      disabled: null
    },  
    {
      key: '09:00',
      name: '09:00',
      disabled: null
    },  
    {
      key: '09:30',
      name: '09:30',
      disabled: null
    },  
    {
      key: '10:00',
      name: '10:00',
      disabled: null
    },  
    {
      key: '10:30',
      name: '10:30',
      disabled: null
    },  
    {
      key: '11:00',
      name: '11:00',
      disabled: null
    },  
    {
      key: '11:30',
      name: '11:30',
      disabled: null
    },  
    {
      key: '12:00',
      name: '12:00',
      disabled: null
    },  
    {
      key: '12:30',
      name: '12:30',
      disabled: null
    },  
    {
      key: '13:00',
      name: '13:00',
      disabled: null
    },  
    {
      key: '13:30',
      name: '13:30',
      disabled: null
    },  
    {
      key: '14:00',
      name: '14:00',
      disabled: null
    },  
    {
      key: '14:30',
      name: '14:30',
      disabled: null
    },  
    {
      key: '15:00',
      name: '15:00',
      disabled: null
    },  
    {
      key: '15:30',
      name: '15:30',
      disabled: null
    },  
    {
      key: '16:00',
      name: '16:00',
      disabled: null
    },  
    {
      key: '16:30',
      name: '16:30',
      disabled: null
    },  
    {
      key: '17:00',
      name: '17:00',
      disabled: null
    },  
    {
      key: '17:30',
      name: '17:30',
      disabled: null
    },  
    {
      key: '18:00',
      name: '18:00',
      disabled: null
    },  
    {
      key: '18:30',
      name: '18:30',
      disabled: null
    },  
    {
      key: '19:00',
      name: '19:00',
      disabled: null
    },  
    {
      key: '19:30',
      name: '19:30',
      disabled: null
    },  
    {
      key: '20:00',
      name: '20:00',
      disabled: null
    },  
    {
      key: '20:30',
      name: '20:30',
      disabled: null
    },  
    {
      key: '21:00',
      name: '21:00',
      disabled: null
    },  
    {
      key: '21:30',
      name: '21:30',
      disabled: null
    },  
    {
      key: '22:00',
      name: '22:00',
      disabled: null
    },  
    {
      key: '22:30',
      name: '22:30',
      disabled: null
    },  
    {
      key: '23:00',
      name: '23:00',
      disabled: null
    },  
    {
      key: '23:30',
      name: '23:30',
      disabled: null
    },  
  ];


  fullTextSearch: string;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_hourly_options_dd_ComponentContextService,
    private _elementRef: ElementRef
    ) {
    super();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  
  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): string | string[] {
    return this._innerValue;
  }

  set value(val: string | string[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }


  displayWithFn(value: any): Promise<string> {
    const displayTextResult = this.options.find(o => o.key === value).name;
    this.displayTextChange.emit(displayTextResult);
    return Promise.resolve(displayTextResult);
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    if (filterText.length > 0) {
      const list = this.options.filter(item => item.name.startsWith(filterText))
      return Promise.resolve({ list, totalCount: this.options.length, top: null });
    } else {
      const list = [...this.options];
      return Promise.resolve({ list, totalCount: this.options.length, top: null });
    }
  }

}
